// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602161304/js/" + chunkId + "." + {"44":"cf1f5345","225":"c4f4788d","481":"c56d3905","486":"b6a0b7d4","770":"4ee19835"}[chunkId] + ".0.9742772152136567.chunk.js";
};